var w = (o) => {
  throw TypeError(o);
};
var G = (o, t, s) => t.has(o) || w("Cannot " + s);
var y = (o, t, s) => t.has(o) ? w("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(o) : t.set(o, s);
var i = (o, t, s) => (G(o, t, "access private method"), s);
var e, T, S, L, p, f, v, B, A, z;
class N {
  constructor({ carouselEl: t, scrollerEl: s, paginationEl: a, slides: O, navBtnEls: P = { next: {}, previous: {} }, options: n }) {
    y(this, e);
    if (!("onscrollend" in window)) {
      let d = function(h, r, b) {
        let c = h[r];
        h[r] = function() {
          let l = Array.prototype.slice.apply(arguments, [0]);
          c.apply(this, l), l.unshift(c), b.apply(this, l);
        };
      }, I = function(h, r, b, c) {
        if (r !== "scroll" && r !== "scrollend")
          return;
        let l = this, u = E.get(l);
        if (u === void 0) {
          let x = 0;
          u = {
            scrollListener: (W) => {
              clearTimeout(x), x = setTimeout(() => {
                m.size ? setTimeout(u.scrollListener, 100) : (l.dispatchEvent(C), x = 0);
              }, 100);
            },
            listeners: 0
            // Count of number of listeners.
          }, h.apply(l, ["scroll", u.scrollListener]), E.set(l, u);
        }
        u.listeners++;
      }, g = function(h, r, b) {
        if (r !== "scroll" && r !== "scrollend")
          return;
        let c = this, l = E.get(c);
        l !== void 0 && (l[r]--, !(--l.listeners > 0) && (h.apply(c, ["scroll", l.scrollListener]), E.delete(c)));
      };
      const C = new Event("scrollend"), m = /* @__PURE__ */ new Set();
      document.addEventListener("touchstart", (h) => {
        for (let r of h.changedTouches)
          m.add(r.identifier);
      }, { passive: !0 }), document.addEventListener("touchend", (h) => {
        for (let r of h.changedTouches)
          m.delete(r.identifier);
      }, { passive: !0 });
      let E = /* @__PURE__ */ new WeakMap();
      d(Element.prototype, "addEventListener", I), d(window, "addEventListener", I), d(document, "addEventListener", I), d(Element.prototype, "removeEventListener", g), d(window, "removeEventListener", g), d(document, "removeEventListener", g);
    }
    this.carouselEl = t, this.scrollerEl = s, this.paginationEl = a, this.slides = O, this.currentIndex = 0, this.slideEls = [...s.children], this.navBtnEls = P, this.currentIntersecting = {}, this.options = n, n.autoplay && (this.timer = null, this.timerInterval = (n == null ? void 0 : n.delay) ?? 3500, this.startTimer()), this.slideGutterSize = (n == null ? void 0 : n.slideGutterSize) ?? 25, this.showPagination = n == null ? void 0 : n.showPagination, this.isInitialScroll = !0, this.totalSlideEls = this.slideEls.length, this.totalSlides = Math.ceil(this.slides.length / this.options.cellsPerSlide), i(this, e, T).call(this), i(this, e, L).call(this), i(this, e, S).call(this);
  }
  /**
   * starts the autoplay timer
   */
  startTimer() {
    this.timer || (this.timer = setInterval(() => {
      this.determineScrollAction(1);
    }, this.timerInterval));
  }
  /**
   * clears the autoplay timer
   */
  clearTimer() {
    clearInterval(this.timer), this.timer = null;
  }
  /**
   * checks to see if the scroller is moving to the
   * end or beginning, if so it makes the appropriate 
   * updates
   * 
   * @param {number} dir - a number representing the direction of scroll 1 for forward, -1 for backward
   */
  determineScrollAction(t) {
    this.options.autoplay && this.timer !== null && this.clearTimer(), t === 1 ? this.currentIndex === this.totalSlides - 1 ? this.options.wrapAround && (this.scrollerEl.style.scrollBehavior = "auto", this.scrollerEl.scrollTo(0, 0), i(this, e, f).call(this, t), this.currentIndex = 0) : (i(this, e, f).call(this, t), this.currentIndex += 1) : t === -1 && (this.currentIndex === 0 ? this.options.wrapAround && (this.scrollerEl.style.scrollBehavior = "auto", this.scrollerEl.scrollTo(99999, 0), this.currentIndex = this.totalSlides - 1, i(this, e, f).call(this, t)) : (i(this, e, f).call(this, t), this.currentIndex -= 1)), this.options.autoplay && this.timer === null && this.startTimer();
  }
  /**
   * Navigates the carousel to a specific index
   * 
   * @param {number} index 
   * @returns void
   */
  navigateToIndex(t) {
    if (t === this.currentIndex) return;
    this.options.autoplay && this.clearTimer();
    let s = t > this.currentIndex ? t - this.currentIndex : this.currentIndex - t, a = t > this.currentIndex ? 1 : -1;
    this.currentIndex = t, i(this, e, f).call(this, a, s), this.options.autoplay && this.startTimer(), i(this, e, v).call(this);
  }
  /**
   * Returns the current index of the carousel
   * 
   * @returns {number} - the current index of the carousel
   */
  getCurrentIndex() {
    return this.currentIndex;
  }
  /**
   * Handles the scrollend event - determines which slide is in view and updates the carousel
   * @returns void
   */
  handleScrollEnd() {
    if (this.timer === null && this.options.autoplay && this.startTimer(), this.currentIntersecting.target) {
      const t = Number.parseInt(this.currentIntersecting.target.getAttribute("data-index"), 10);
      if (!this.options.wrapAround) {
        this.currentIndex = t, i(this, e, v).call(this);
        return;
      }
      t === 0 ? (this.currentIndex = this.slides.length - 1, i(this, e, p).call(this, { scrollport: this.scrollerEl, element: this.slideEls[this.totalSlides] })) : t === this.totalSlideEls - 1 ? (this.currentIndex = 0, i(this, e, p).call(this, { scrollport: this.scrollerEl, element: this.slideEls[1] })) : this.currentIndex = t - 1;
    }
    i(this, e, v).call(this);
  }
}
e = new WeakSet(), /**
 * adds an observer to the scroller element that we can use to 
 * determine which slide is intersecting
 */
T = function() {
  this.carouselObserver = new IntersectionObserver((t) => {
    for (let s of t)
      s.isIntersecting && (this.currentIntersecting = s);
  }, {
    root: this.scrollerEl,
    threshold: 0.8
  });
}, /**
 * sets listeners on the slide elements for the observer
 */
S = function() {
  for (let t of this.slideEls)
    this.carouselObserver.observe(t);
}, /**
 * sets some intial settings for the carousel based on some of the options
 */
L = function() {
  this.options.wrapAround ? (this.scrollerEl.style.scrollBehavior = "auto", this.scrollerEl.scrollTo(-9999, 0), i(this, e, p).call(this, { scrollport: this.scrollerEl, element: this.scrollerEl.children[1] })) : this.options.showControls ? (this.navBtnEls.previous.setAttribute("disabled", !0), i(this, e, v).call(this)) : i(this, e, A).call(this), this.totalSlides === 1 && this.slideEls[0].removeAttribute("inert");
}, /**
 * Scrolls the carousel to a specific child element
 * @param {*} param0 - an object containing the scrollport element and the child element to scroll to 
 */
p = function({ scrollport: t, element: s }) {
  const a = this.slideGutterSize * 2 / 100;
  t.style.scrollBehavior = "auto", t.scrollTo(Math.abs(t.offsetLeft - s.offsetLeft + s.clientWidth * a), 0);
}, /**
 * Scrolls the carousel in a specified direction by a specified distance
 * 
 * @param {number} dir - a number representing the direction of scroll 1 for forward, -1 for backward 
 * @param {number} distance - a number representing the number of slides to scroll
 */
f = function(t, s = 1) {
  this.scrollerEl.style.scrollBehavior = "smooth", this.scrollerEl.scrollBy({
    left: this.scrollerEl.clientWidth * ((100 - this.slideGutterSize * 2) / 100) * s * t,
    top: 0,
    behavior: "smooth"
  });
}, /**
 * Syncronizes various elements of the carousel
 * 
 * add methods here to have them sync 
 * when scroller is scrolled
 */
v = function() {
  i(this, e, A).call(this), this.showPagination && i(this, e, z).call(this), this.options.wrapAround || i(this, e, B).call(this);
}, /**
 * Sets the control arrow buttons to disabled if the carousel is at the start or end
 */
B = function() {
  this.navBtnEls.previous && this.navBtnEls.next && (this.navBtnEls.previous.removeAttribute("disabled"), this.navBtnEls.next.removeAttribute("disabled"), this.currentIndex === 0 && this.navBtnEls.previous.toggleAttribute("disabled"), this.currentIndex === this.slideEls.length - 1 && this.navBtnEls.next.toggleAttribute("disabled"));
}, /**
 * Sets the inert attribute on all slides that are not the current slide
 */
A = function() {
  const t = this.options.wrapAround ? this.currentIndex + 1 : this.currentIndex;
  this.slideEls.length === 1 ? this.slideEls[0].removeAttribute("inert") : this.slideEls.forEach((s, a) => {
    s.toggleAttribute("inert", a !== t);
  });
}, /**
 * Sets the pagination indicator to the current slide
 */
z = function() {
  [...this.paginationEl.children].forEach((t, s) => {
    s === this.currentIndex ? t.setAttribute("data-current", "true") : t.setAttribute("data-current", "false");
  });
};
export {
  N as default
};
